import { createContext, useContext } from 'react';
import type { TaskUpdateEvent } from '../../shared/types/socket';

export interface ProjectSocketContextValue {
  emitTaskUpdate: (event: Omit<TaskUpdateEvent, 'projectId' | 'clientTs'>) => void;
  emitTaskLock:   (taskId: string) => void;
  emitTaskUnlock: (taskId: string) => void;
}

const noop = () => undefined;

export const ProjectSocketContext = createContext<ProjectSocketContextValue>({
  emitTaskUpdate: noop,
  emitTaskLock:   noop,
  emitTaskUnlock: noop,
});

export const useProjectSocketContext = (): ProjectSocketContextValue =>
  useContext(ProjectSocketContext);
